import { render, staticRenderFns } from "./PRO_ByDxPrintable.vue?vue&type=template&id=2a3aa937&scoped=true&"
import script from "./PRO_ByDxPrintable.vue?vue&type=script&lang=js&"
export * from "./PRO_ByDxPrintable.vue?vue&type=script&lang=js&"
import style0 from "./PRO_ByDxPrintable.vue?vue&type=style&index=0&id=2a3aa937&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3aa937",
  null
  
)

export default component.exports